export default {
    "created": "Evenimentul a fost creat cu succes",
    "updated": "Evenimentul a fost actualizat cu succes",
    "deleted": "Evenimentul a fost șters cu succes",
    "restored": "Evenimentul a fost restaurat cu succes",
}
